<script>
import { PageTree } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Page',
      addRoute: { name: 'Add Page' },
      verboseName: 'Page',
      verboseNamePlural: 'Pages',
      isPaginated: false,
      isTree: true,
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'title_en', label: 'title (en)' },
        { prop: 'slug_en', label: 'slug (en)' },
        { prop: 'slug_de', label: 'slug (de)' },
        { prop: 'is_home', label: 'home', type: 'boolean' }
      ]
    }
  },
  computed: {
    service() {
      return PageTree
    }
  }
}
</script>
